import { AxiosInterceptor } from '../../Config/AxiosInterceptor'
import { AuthXInterceptor } from '../Config/AuthXInterceptor'

AxiosInterceptor()

export const priceMatchBXService = {
  list: async (params: {
    page?: number
    limit?: number
    sortOrder?: 'ASC' | 'DESC'
    status?: string
  }) => {
    const queryParams: Record<string, string | number> = {}

    if (params.page !== undefined) queryParams.page = params.page
    if (params.limit !== undefined) queryParams.limit = params.limit
    if (params.sortOrder) queryParams.sortOrder = params.sortOrder
    if (params.status) queryParams.status = params.status

    return await AuthXInterceptor.get('price-matches', {
      params: queryParams,
      headers: {
        accept: 'application/json',
      },
    })
  },

  show: async (priceMatchId: string) => {
    return await AuthXInterceptor.get(`price-matches/${priceMatchId}`, {
      headers: {
        accept: 'application/json',
      },
    })
  },

  approve: async (priceMatchId: string, payload: { priceDifferenceMajor: number }) => {
    return await AuthXInterceptor.put(`price-matches/${priceMatchId}/approve`, payload, {
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
  },

  reject: async (priceMatchId: string, payload: { rejectionNote: string }) => {
    return await AuthXInterceptor.put(`price-matches/${priceMatchId}/reject`, payload, {
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
  },
}
